import React, { Component } from "react";
import { connect } from "react-redux";
import Loadable from "react-loadable";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import { withTitle } from "~/components/common/molecules/TitleHelmet";
import { searchElectricInvoice } from "~/store/invoice/actions";
import moment from "moment";
import { partnerInfo } from "~/configs/partnerDetails";
import { get, find } from "lodash";

const info = get(partnerInfo, "info");
const hospitalName = find(info, { key: "name" });

const SearchElectronicInvoicePageMobile = Loadable({
  loader: () =>
    import(/* mobile */ "~/components/desktop/pages/ElectronicInvoicesSearch"),
  loading: LoadableLoading
});
const SearchElectronicInvoicePageDesktop = Loadable({
  loader: () =>
    import(/* desktop */ "~/components/desktop/pages/ElectronicInvoicesSearch"),
  loading: LoadableLoading
});

class SearchElectronicInvoice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      invoiceCode: "",
      date: "",
      errorInvoiceCode: "",
      errorDate: ""
    };
  }

  validatorDate = date => {
    if (!date || !moment(date, "DD/MM/YYYY").isValid()) {
      return false;
    }
    return true;
  };

  methods = {
    onSearchInvoiceCode: () => {
      const { invoiceCode, date } = this.state;
      if (!invoiceCode) {
        this.setState({
          errorInvoiceCode: "Vui lòng nhập mã hóa đơn."
        });
      } else if (!this.validatorDate(date)) {
        this.setState({
          errorDate: "Vui lòng nhập đúng định dạng ngày tháng năm."
        });
      } else {
        const postData = {
          MaTraCuu: invoiceCode,
          NgayHoaDon: date
        };
        this.props.searchElectricInvoice(postData);
      }
    },
    onChangeInvoiceCode: code => {
      this.setState({
        invoiceCode: code,
        errorInvoiceCode: code === "" ? "Vui lòng nhập mã hóa đơn." : ""
      });
    },
    onChangeDate: date => {
      this.setState({
        date,
        errorDate: this.validatorDate(date)
          ? ""
          : "Vui lòng nhập đúng định dạng ngày tháng năm."
      });
    },
    handleGoBack: () => {
      const { history } = this.props;
      history.push("/");
    }
  };

  render() {
    const { device } = this.props;
    return (
      <React.Fragment>
        {device === "mobile" ? (
          <SearchElectronicInvoicePageMobile
            {...this.props}
            {...this.methods}
            {...this.state}
          />
        ) : (
          <SearchElectronicInvoicePageDesktop
            {...this.props}
            {...this.methods}
            {...this.state}
          />
        )}
      </React.Fragment>
    );
  }
}
const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    },
    fee: { hosNumber, fee, loading }
  } = state;
  return {
    device: type,
    hosNumber,
    fee,
    loading
  };
};

const SearchElectronicInvoiceHelmet = withTitle({
  component: SearchElectronicInvoice,
  title: `${hospitalName.value} | Tra cứu hóa đơn điện tử`
});

export default connect(mapStateToProps, {
  searchElectricInvoice
})(SearchElectronicInvoiceHelmet);
